export default __webpack_public_path__ + "static/media/about-page-img.2a0268f4.jpeg";